const LEGACY_ERROR_CODE_PROPS = ["result", "statusCode"];
const DEFAULT_ERROR_CODE_PROP = "code";
const DEFAULT_ERROR_CODE = 0;
const LEGACY_ERROR_MSG_PROPS = ["alertMsg", "message"];
const DEFAULT_ERROR_MSG_PROP = "msg";
const DEFAULT_ERROR_MSG = "Error";
function getErrorCodeFromData(data = {}) {
  let errorCode = data[DEFAULT_ERROR_CODE_PROP];
  if (typeof errorCode === "undefined") {
    LEGACY_ERROR_CODE_PROPS.forEach((key) => {
      if (data[key] !== void 0) {
        errorCode = data[key];
      }
    });
  }
  if (typeof errorCode === "undefined") {
    errorCode = DEFAULT_ERROR_CODE;
  }
  return errorCode;
}
function getErrorMsgFromData(data = {}) {
  let errorMsg = data[DEFAULT_ERROR_MSG_PROP];
  if (typeof errorMsg === "undefined") {
    LEGACY_ERROR_MSG_PROPS.forEach((key) => {
      if (data[key]) {
        errorMsg = data[key];
      }
    });
  }
  if (typeof errorMsg === "undefined") {
    errorMsg = DEFAULT_ERROR_MSG;
  }
  return errorMsg;
}
class HTTPClientError extends Error {
  constructor(code, message) {
    super(message);
    this.name = "HTTPClientError";
    this.msg = message;
    this.status = code;
    this.code = code;
  }
}
class HTTPServerError extends Error {
  constructor(status, data) {
    super(data.msg);
    this.name = "HTTPServerError";
    this.code = data[DEFAULT_ERROR_CODE_PROP];
    this.msg = data[DEFAULT_ERROR_MSG_PROP];
    this.status = status;
    this.data = data;
  }
}
class HTTPBizError extends HTTPServerError {
  constructor(...params) {
    super(...params);
    this.name = "HTTPBizError";
  }
}

export { DEFAULT_ERROR_CODE_PROP, DEFAULT_ERROR_MSG_PROP, HTTPBizError, HTTPClientError, HTTPServerError, getErrorCodeFromData, getErrorMsgFromData };
